import { IBaseAction } from '../../constants';
export interface Props {
    number?: any;
    config?: any;
    expand?: any;
    shouldCheck?: any;
    user?: any;
    serverErrorMessages?: any;
    serverInfoMessages?: any;
    type?: any;
    status?: any;
    flightDetails?: any;
    onAccordionClick?: any;
    setShouldCheck?: any;
    setFlightRequest?: any;
    setIsActed?: any;
    setServerErrorMessages?: any;
    isOpen?: boolean;
    allClosed?: boolean;
    // temporary
    serverErrors?: any;
    requestErrors?: any;
    submitRpl?: any
    setConfirmedRplRequest?: any
    setOpenDialog?: any
    setHasError?: any
    setCurrentAccordion?: any
    setHasOffer?: any
    candidateGroup: string;
    goingFlight?: any;
    flightConfirm?: any;
    flightOffer?: any;
    flightReject?: any;
    flightIsChanged?: any;
}
export interface CityNamesType {
    value: any;
    label: any;
    type?: string;
}

export interface FlightDetails {
    type: string;
    type_desc?: string;
    airline: string;
    incoming: boolean;
    source: string;
    destinations: string[];
    flightNumber: string;
    register: string;
    airplaneType: string;
    nightStay: boolean;
    startDate: Date;
    endDate: Date;
    rangeStartDate?: Date;
    rangeEndDate?: Date;
    baseStartDate?: Date;
    baseEndDate?: Date;
    baseDepartureTime?: Date;
    baseEntranceTime?: Date;
    entranceTime?: Date;
    departureTime?: Date;
    requestNumber: string;
    multipleRoutes?: boolean;
    daysOfWeek?: number[];
    confirmed?: boolean;
    rejected?: boolean;
    offer?: boolean;
}

export interface Flight {
    type: string;
    airline: string;
    flightId: string;
    incoming: boolean;
    twoWay: boolean;
    goingWay: boolean;
    comingway: boolean;
    source: string;
    destinations: string[];
    flightNumber: string;
    confirmedMonitoring?: boolean;
    register: string;
    airplaneType: string;
    nightStay: boolean;
    startDate: Date;
    endDate: Date;
    rangeStartDate?: Date;
    rangeEndDate?: Date;
    baseStartDate?: Date;
    baseEndDate?: Date;
    baseDepartureTime?: Date;
    baseEntranceTime?: Date;
    entranceTime?: Date;
    departureTime?: Date;
    requestNumber: string;
    multipleRoutes?: boolean;
    daysOfWeek?: number[];
    confirmed?: boolean;
    rejected?: boolean;
    offer?: boolean;
    status: string;
    newEndDate?: Date;
    newStartDate?: Date;
    newEntranceTime?: Date;
    newDepartureTime?: Date;
    ranges?: any[];
    daysToBeTimeChanged?: number[];
}

export interface FlightRequest {
    type: string;
    type_desc?: string;
    summerSeason?: Boolean;
    airline: string;
    flights: Flight[];
    generatedFlights: Flight[];
    monitoringNumber?: string;
    status: string;
    instanceId: string;
    taskId: string;
    monitoringNumberFile?: string;
    rejectionDescription?: string;
    reasonsOfRejection?: string[];
    candidateGroup: string;
    updatedAt?: Date;
    requesterName?: string;
    airlineLogo: string;
    rpl?: any;
    flightNumber?: string;
    id: string;
}

export interface FlightRequestsState {
    data: FlightRequest;
}

export interface FlightRequestInitialState {
    flightRequest: FlightRequest;
}
export const GET_FLIGHT_REQUEST = 'GET_FLIGHT_REQUEST';
export const GET_FLIGHT_REQUEST_SUCCESS = 'GET_FLIGHT_REQUEST_SUCCESS';
export const GET_FLIGHT_REQUEST_FAILURE = 'GET_FLIGHT_REQUEST_FAILURE';
export const GET_FLIGHT_REQUEST_CLEAR = 'GET_FLIGHT_REQUEST_CLEAR';
interface GetFlightRequestsList extends IBaseAction {
    type: typeof GET_FLIGHT_REQUEST | typeof GET_FLIGHT_REQUEST_SUCCESS | typeof GET_FLIGHT_REQUEST_CLEAR | typeof GET_FLIGHT_REQUEST_FAILURE;
    payload: {
        data: FlightRequestInitialState;
    };
}

export interface SaveFlightRequestInitialState { }
export const SAVE_FLIGHT_REQUEST = 'SAVE_FLIGHT_REQUEST';
export const SAVE_FLIGHT_REQUEST_SUCCESS = 'SAVE_FLIGHT_REQUEST_SUCCESS';
export const SAVE_FLIGHT_REQUEST_FAILURE = 'SAVE_FLIGHT_REQUEST_FAILURE';
export const SAVE_FLIGHT_REQUEST_CLEAR = 'SAVE_FLIGHT_REQUEST_CLEAR';
export interface SaveFlightRequestAction extends IBaseAction {
    type:
    | typeof SAVE_FLIGHT_REQUEST
    | typeof SAVE_FLIGHT_REQUEST_SUCCESS
    | typeof SAVE_FLIGHT_REQUEST_FAILURE
    | typeof SAVE_FLIGHT_REQUEST_CLEAR;
    payload?: {
        data: SaveFlightRequestInitialState;
    };
}

export interface ApproveFlightRequestInitialState { }
export const APPROVE_FLIGHT_REQUEST = 'APPROVE_FLIGHT_REQUEST';
export const APPROVE_FLIGHT_REQUEST_SUCCESS = 'APPROVE_FLIGHT_REQUEST_SUCCESS';
export const APPROVE_FLIGHT_REQUEST_FAILURE = 'APPROVE_FLIGHT_REQUEST_FAILURE';
export const APPROVE_FLIGHT_REQUEST_CLEAR = 'APPROVE_FLIGHT_REQUEST_CLEAR';
export interface ApproveFlightRequestAction extends IBaseAction {
    type:
    | typeof APPROVE_FLIGHT_REQUEST
    | typeof APPROVE_FLIGHT_REQUEST_SUCCESS
    | typeof APPROVE_FLIGHT_REQUEST_FAILURE
    | typeof APPROVE_FLIGHT_REQUEST_CLEAR;
    payload?: {
        data: ApproveFlightRequestInitialState;
    };
}

export interface RejectFlightRequestInitialState { }
export const REJECT_FLIGHT_REQUEST = 'REJECT_FLIGHT_REQUEST';
export const REJECT_FLIGHT_REQUEST_SUCCESS = 'REJECT_FLIGHT_REQUEST_SUCCESS';
export const REJECT_FLIGHT_REQUEST_FAILURE = 'REJECT_FLIGHT_REQUEST_FAILURE';
export const REJECT_FLIGHT_REQUEST_CLEAR = 'REJECT_FLIGHT_REQUEST_CLEAR';
export interface RejectFlightRequestAction extends IBaseAction {
    type:
    | typeof REJECT_FLIGHT_REQUEST
    | typeof REJECT_FLIGHT_REQUEST_SUCCESS
    | typeof REJECT_FLIGHT_REQUEST_FAILURE
    | typeof REJECT_FLIGHT_REQUEST_CLEAR;
    payload?: {
        data: RejectFlightRequestInitialState;
    };
}

export interface OfferFlightRequestInitialState { }
export const OFFER_FLIGHT_REQUEST = 'OFFER_FLIGHT_REQUEST';
export const OFFER_FLIGHT_REQUEST_SUCCESS = 'OFFER_FLIGHT_REQUEST_SUCCESS';
export const OFFER_FLIGHT_REQUEST_FAILURE = 'OFFER_FLIGHT_REQUEST_FAILURE';
export const OFFER_FLIGHT_REQUEST_CLEAR = 'OFFER_FLIGHT_REQUEST_CLEAR';
export interface OfferFlightRequestAction extends IBaseAction {
    type:
    | typeof OFFER_FLIGHT_REQUEST
    | typeof OFFER_FLIGHT_REQUEST_SUCCESS
    | typeof OFFER_FLIGHT_REQUEST_FAILURE
    | typeof OFFER_FLIGHT_REQUEST_CLEAR;
    payload?: {
        data: OfferFlightRequestInitialState;
    };
}

export interface SubmitOfferFlightRequestInitialState { }
export const SUBMIT_OFFER_FLIGHT_REQUEST = 'SUBMIT_OFFER_FLIGHT_REQUEST';
export const SUBMIT_OFFER_FLIGHT_REQUEST_SUCCESS = 'SUBMIT_OFFER_FLIGHT_REQUEST_SUCCESS';
export const SUBMIT_OFFER_FLIGHT_REQUEST_FAILURE = 'SUBMIT_OFFER_FLIGHT_REQUEST_FAILURE';
export const SUBMIT_OFFER_FLIGHT_REQUEST_CLEAR = 'SUBMIT_OFFER_FLIGHT_REQUEST_CLEAR';
export interface SubmitOfferFlightRequestAction extends IBaseAction {
    type:
    | typeof SUBMIT_OFFER_FLIGHT_REQUEST
    | typeof SUBMIT_OFFER_FLIGHT_REQUEST_SUCCESS
    | typeof SUBMIT_OFFER_FLIGHT_REQUEST_FAILURE
    | typeof SUBMIT_OFFER_FLIGHT_REQUEST_CLEAR;
    payload?: {
        data: SubmitOfferFlightRequestInitialState;
    };
}

export type GetFlightRequestActionTypes =
    | GetFlightRequestsList
    | ApproveFlightRequestAction
    | SaveFlightRequestAction
    | RejectFlightRequestAction
    | OfferFlightRequestAction
    | SubmitOfferFlightRequestAction
